import React from 'react';
interface IconProps {
  width?: string;
  height?: string;
}

export const DoctorIcon: React.FC<IconProps> = ({ width = 25, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.66699 14.566V15.5C7.66699 19.09 10.577 22 14.167 22C15.891 22 17.544 21.315 18.763 20.096C19.982 18.877 20.667 17.224 20.667 15.5V12.829C21.832 12.417 22.667 11.305 22.667 10C22.667 8.344 21.323 7 19.667 7C18.011 7 16.667 8.344 16.667 10C16.667 11.305 17.502 12.417 18.667 12.829V15.5C18.667 16.693 18.193 17.838 17.349 18.682C16.505 19.526 15.36 20 14.167 20C11.682 20 9.66699 17.985 9.66699 15.5V14.566L12.725 12.731C13.93 12.009 14.667 10.706 14.667 9.301V3C14.667 2.448 14.219 2 13.667 2H10.667V4H12.667V9.301C12.667 10.004 12.298 10.655 11.696 11.016L8.66699 12.834L5.63799 11.016C5.03599 10.655 4.66699 10.004 4.66699 9.301V4H6.66699V2H3.66699C3.11499 2 2.66699 2.448 2.66699 3V9.301C2.66699 10.706 3.40399 12.009 4.60899 12.731L7.66699 14.566ZM19.667 9C20.219 9 20.667 9.448 20.667 10C20.667 10.552 20.219 11 19.667 11C19.115 11 18.667 10.552 18.667 10C18.667 9.448 19.115 9 19.667 9Z'
        fill='#04A0C5'
      />
    </svg>
  );
};
